import { fleetManagementApi } from "../api";

export const fetchDashboardStats = async (params) => {
  return await fleetManagementApi.get("/dashboard/stats", { params });
}

export const fetchBookingTrends = async (params) => {
  return await fleetManagementApi.get("/dashboard/booking-trends", { params });
}

export const fetchDriverBookingPerformance = async (params) => {
  return await fleetManagementApi.get("/dashboard/driver-booking-performance", { params });
}

export const fetchVehicleBookingCounts = async (params) => {
  return await fleetManagementApi.get("/dashboard/vehicle-booking-counts", { params });
}

export const fetchVehicleCategoryDistribution = async (params) => {
  return await fleetManagementApi.get("/dashboard/vehicle-category-distribution", { params });
}

export const fetchTodayRevenueExpense = async (params) => {
  return await fleetManagementApi.get("/dashboard/today-revenue-expense", { params });
}

export const fetchVehicleAvailabilityCalendar = async (params) => {
  return await fleetManagementApi.get("/dashboard/vehicle-availability-calendar", {params});
}